import * as React from "react"
import { tCartItem, tCartContext } from "../../types"

const initialState = {
  items: {},
  paidItems: {},
  addToCart: () => {},
  itemIsInCart: () => {},
  emptyCart: () => {},
  removeFromCart: () => {},
  setItemsPaid: () => {}
}

const { Provider, Consumer } = React.createContext(initialState)

export const CartContext = Consumer

type tCartContextContainer = {
  children: React.Node
}

export class CartContextContainer extends React.Component<
  tCartContextContainer,
  tCartContext
> {
  ITEMS_STORAGE_KEY = "center-for-spiritual-living-cart-items"
  PAID_ITEMS_STORAGE_KEY = "center-for-spiritual-living-cart-paid-items"
  componentDidMount = () => {
    if (typeof document !== "undefined") {
      const itemsCache = localStorage.getItem(this.ITEMS_STORAGE_KEY)
      const paidItemsCache = localStorage.getItem(this.PAID_ITEMS_STORAGE_KEY)

      if (itemsCache) {
        try {
          const items = JSON.parse(itemsCache)
          this.setState({ items })
        } catch (error) {
          throw error
        }
      }

      if (paidItemsCache) {
        try {
          const paidItems = JSON.parse(paidItemsCache)
          this.setState({ paidItems })
        } catch (error) {
          throw error
        }
      }
    }
  }
  setItemsPaid = () => {
    this.setState(
      (prevState) => ({
        items: {},
        paidItems: {
          ...prevState.paidItems,
          ...prevState.items
        }
      }),
      () => {
        this.updateLocalStorage(
          this.PAID_ITEMS_STORAGE_KEY,
          this.state.paidItems
        )
        this.updateLocalStorage(this.ITEMS_STORAGE_KEY, this.state.items)
      }
    )
  }
  updateLocalStorage = (key, value) => {
    if (typeof document !== "undefined") {
      const item = JSON.stringify(value)
      if (item) localStorage.setItem(key, item)
    }
  }
  itemIsInCart = (id: string) => {
    return this.state.items[id]
  }
  addToCart = (item: tCartItem) => {
    this.setState(
      (prevState) => ({
        items: {
          ...prevState.items,
          [item.id]: item
        }
      }),
      () => this.updateLocalStorage(this.ITEMS_STORAGE_KEY, this.state.items)
    )
  }
  removeFromCart = (id: string) => {
    this.setState(
      (prevState) => {
        const { [id]: value, ...items } = prevState.items

        return {
          ...prevState,
          items
        }
      },
      () => this.updateLocalStorage(this.ITEMS_STORAGE_KEY, this.state.items)
    )
  }
  emptyCart = () =>
    this.setState({ items: {} }, () =>
      this.updateLocalStorage(this.ITEMS_STORAGE_KEY, this.state.items)
    )
  state = {
    ...initialState,
    addToCart: this.addToCart,
    itemIsInCart: this.itemIsInCart,
    emptyCart: this.emptyCart,
    removeFromCart: this.removeFromCart,
    setItemsPaid: this.setItemsPaid
  }
  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/CartContext/index.js